export default "__VITE_ASSET__CG0DCt7A__"